module.exports = __webpack_public_path__ + "static/media/StructuralAnalysis1.b1043424.svg";